<template>
  <div>
    <h2 class="mt-1 ml-15 hidden-sm-and-down grey--text">Importaciones</h2> <!-- Full Screen -->
    <h3 class="mt-1 hidden-sm-and-up grey--text">Importaciones</h3> <!-- Mobile Screen -->
    <div class="mt-5">
      <v-bottom-navigation :value="value" color="success">
        <v-btn @click="OpenComponent(0)" :disabled="comp0">      
          <span>Solicitud</span>
          <v-icon>{{SolicitaIcon}}</v-icon>
        </v-btn>
        <v-btn @click="OpenComponent(1)" :disabled="comp1">      
          <span>Importación</span>
          <v-icon>{{ImportaIcon}}</v-icon>
        </v-btn>
        <v-btn @click="OpenComponent(2)" :disabled="comp2">
          <span>Integración</span>
          <v-icon>{{IntegraIcon}}</v-icon>
        </v-btn>
      </v-bottom-navigation>
      <div v-if="Importaciones=='V'" class="mt-2">
      
          <component v-bind:is="componente" :usu="usu" :contrato="contrato"></component>
      
      </div>
      <div v-if="Importaciones=='N'">
        <v-row class="mt-15">
          <v-col cols="1" md="4"></v-col>
          <v-col cols="10" md="4">
            <v-card rounded="xl">
              <v-card-text>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <span class="text-body-2">
                            Este módulo no está incluido en tu plan actual.
                            <br><br>
                            Puedes activarlo en cualquier momento como un complemento independiente, sin necesidad de cambiar de plan
                            <br><br>
                            Comunicate con soporte o visita nuestro sitio Web
                            <br>
                            <a target="_blank" href="https://www.bodeganet.cl">www.bodeganet.cl</a>
                        </span>
                    </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="1" md="4"></v-col>
        </v-row>
      </div>

    </div>
    <dialogo :loading="loading"  />
  </div>
</template>
<script>
import axios from 'axios';
import Solicita from '@/components/Solicita.vue';
import Importa from '@/components/Importa.vue';
import Integra from '@/components/Integra.vue';
import dialogo from '@/components/dialogo.vue';
export default {
  name: 'Importaciones',
  components: { Solicita, Importa, Integra ,dialogo},
  props: ['usu','contrato'],
  data(){
    return{
      loading:false,
      value:null,
      componente:'',
      IconSelect:'check_circle',
      SolicitaIcon:'monetization_on',
      ImportaIcon:'monetization_on',
      IntegraIcon:'monetization_on',
      IconDefault:'monetization_on',
      comp0:true,
      comp1:true,
      comp2:true,
      Importaciones:'',
    }
  },
  async mounted(){
    const auth = await this.AuthModules();
    if(auth=='V'){
      await this.entrada();
    }
  },
   methods:{
    async AuthModules(){
      let result = 'N'
        try {
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/autoriza_modulos/'+this.contrato);
            const datos=response.data;
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    const key = element.Modulo;
                    if(key == "Importaciones"){
                        result = element.Estado;
                        this.Importaciones = element.Estado
                    }
                });
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async entrada(){
      this.loading=true;
      const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/usuarios/'+this.contrato+'/'+this.usu);
      const datos=response.data;
      if (datos[0].existe=='si'){
        if(datos[0].Permiso_9_1!=0) {
          this.comp0=false;
        };
        if(datos[0].Permiso_9_2!=0) {
          this.comp1=false;
        };
        if(datos[0].Permiso_9_3!=0) {
          this.comp2=false;
        };
      }
      this.moduloActivo();
      this.loading=false;       
    },
    moduloActivo(){
      if (this.comp0!=true){
          this.componente='Solicita';
          this.SolicitaIcon=this.IconSelect;
          this.ImportaIcon=this.IconDefault;
          this.IntegraIcon=this.IconDefault;
          this.value=0
      } else {
          if (this.comp1!=true){
            this.componente='Importa';
            this.SolicitaIcon=this.IconDefault;
            this.ImportaIcon=this.IconSelect;
            this.IntegraIcon=this.IconDefault;
            this.value=1
          } else {
            if (this.comp2!=true){
              this.componente='Integra';
              this.SolicitaIcon=this.IconDefault;
              this.ImportaIcon=this.IconDefault;
              this.IntegraIcon=this.IconSelect;
              this.value=2
            } else {
                this.IntegraIcon=this.IconDefault;
                this.ImportaIcon=this.IconDefault;
                this.SolicitaIcon=this.IconDefault;
            }
          }
      }
      this.loading=false;
    },
    OpenComponent(value){
      let vComponente;
      switch (value) {
        case 0:
          vComponente='Solicita';
          this.SolicitaIcon=this.IconSelect;
          this.ImportaIcon=this.IconDefault;
          this.IntegraIcon=this.IconDefault;
          break;
        case 1:
          vComponente='Importa';
          this.SolicitaIcon=this.IconDefault;
          this.ImportaIcon=this.IconSelect;
          this.IntegraIcon=this.IconDefault;
        break;
        case 2:
          vComponente='Integra';
          this.SolicitaIcon=this.IconDefault;
          this.ImportaIcon=this.IconDefault;
          this.IntegraIcon=this.IconSelect;
        break;
      }
      this.componente=vComponente;
    }
  }
}
</script>